import React from 'react';
import './index.scss';

export const InputList = (props) => {
  const classes = `input-list ${props.class}`;

  return <div className={classes}>{props.children}</div>;
};
